import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { use_component_is_mounted } from '@/hooks/is_mounted/use_component_is_mounted';
import { SVGComponent } from '@/types/types';
import { cn } from '@/utils/utils_client';
import { CALLBACK__void } from '@shared/types/types';
import { forwardRef } from 'react';

interface Props {
  Icon: SVGComponent;
  className?: string;
  classNameNonHovered?: string;
  classNameHovered?: string;
  isHovered?: boolean;
  renderDelay?: number;
  enableAnimation?: boolean;
  onClick?: CALLBACK__void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const UI_PRIMITIVE__icon_animated = forwardRef<HTMLSpanElement, Props>(function IconAnimated(
  {
    Icon,
    className = '',
    classNameNonHovered = '',
    classNameHovered = '',
    isHovered,
    renderDelay = CONSTANTS__client.INSTANT_RENDER_ANIMATION_DELAY,
    enableAnimation = true,
    onClick = () => {},
    ...props
  },
  ref,
) {
  const { is_mounted } = use_component_is_mounted(renderDelay);

  return (
    <span className={cn(`flex-center`, className)} {...{ onClick, ref }} {...props}>
      <Icon
        className={cn(
          `         flex-center
                    cursor-pointer hover-animation`,
          is_mounted && enableAnimation ? '!scale-100 !opacity-90' : '!scale-50 !opacity-0',
          isHovered ? classNameHovered : classNameNonHovered,
          className,
        )}
      />
    </span>
  );
});
